import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';
import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import CheckboxInputField from 'components/layout/forms/CheckboxInputField';
import getChecked from 'services/forms/getChecked';
import translations from 'services/translations/translations';
import DraggableModal from './src/DraggableModal';
import getTargetName from '../../../services/forms/getTargetName';
import ISnapShotOptions from '../../interfaces/ISnapShotOptions';
import defaultSnapShotOptions from './defaultSnapShotOptions';

const SnapshotModal = ({
  takeSnapshot,
  closeModal,
}: {
  takeSnapshot: (options: ISnapShotOptions) => void;
  closeModal: () => void;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);
  const [activeMeasurements, setActiveMeasurements] =
    useState<ISnapShotOptions>(defaultSnapShotOptions);
  const handleActiveMeasurements = (e: any) => {
    const measurementsOption = getChecked(e);
    const name = getTargetName(e);
    setActiveMeasurements({
      ...activeMeasurements,
      [name]: measurementsOption,
    });
  };
  return (
    <DraggableModal closeModalNotSaved={closeModal}>
      <Row>
        <Col>
          <CheckboxInputField
            id="snapshotincludewalldimensions"
            label={t(`${translations.common}:Include Wall Dimension`)}
            onChange={handleActiveMeasurements}
            value={activeMeasurements.snapshotincludewalldimensions}
            name="snapshotincludewalldimensions"
            required
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <CheckboxInputField
            id="snapshotincludewallname"
            label={t(`${translations.common}:Include Wall Name`)}
            onChange={handleActiveMeasurements}
            value={activeMeasurements.snapshotincludewallname}
            name="snapshotincludewallname"
            required
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <CheckboxInputField
            id="snapshotincludefloor"
            label={t(`${translations.common}:Include Floor`)}
            onChange={handleActiveMeasurements}
            value={activeMeasurements.snapshotincludefloor}
            name="snapshotincludefloor"
            required
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <CheckboxInputField
            id="snapshotincludebuildingwall"
            label={t(`${translations.common}:Include Building Wall`)}
            onChange={handleActiveMeasurements}
            value={activeMeasurements.snapshotincludebuildingwall}
            name="snapshotincludebuildingwall"
            required
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <PrimaryButton
            className="primary-button button-edit-popup"
            onClick={() => takeSnapshot(activeMeasurements)}
          >
            {t(`${translations.common}:Download`).toLocaleUpperCase()}
          </PrimaryButton>
        </Col>
      </Row>
    </DraggableModal>
  );
};

export default SnapshotModal;
